// src/components/Footer.js

import React from 'react'

function Footer() {
  return (
    <div id="footer">
      <p>
        <span>The Via Project 2026</span>
        <a href="/#/credits/">MEDIA CREDITS</a>
        <a href="/#/support/">SUPPORT</a>
        <a href="mailto:contact@via-project.org">CONTACT</a>
      </p>
    </div>
  )
}

export default Footer
